import axios from 'axios';
import VueAxios from 'vue-axios';
import Vue from 'vue';
// import router from '../router';
Vue.use(VueAxios, axios);

axios.defaults.withCredentials = true;

// 重试次数
axios.defaults.retry = false;

// 重试次数
axios.defaults.retryCount = 1;

// 重试延时
axios.defaults.retryDelay = 1000;

// 请求拦截器
axios.interceptors.request.use(
  // eslint-disable-next-line prettier/prettier
  function(config) {
    if (localStorage['external-token']) {
      // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers['external-token'] = localStorage['external-token'];
    }
    return config;
  },
  // eslint-disable-next-line prettier/prettier
  function(error) {
    return Promise.reject(error);
  }
);

// 响应拦截器
axios.interceptors.response.use(
  response => {
    return response;
  },
  err => {
    var config = err.config;
    // 判断是否配置了重试
    if (!config || !config.retry) return Promise.reject(err);

    // 设置重置次数，默认为0
    config.__retryCount = config.__retryCount || 0;

    // 判断是否超过了重试次数
    if (config.__retryCount >= config.retryCount) {
      return Promise.reject(err);
    }

    // 重试次数自增
    config.__retryCount += 1;

    // 延时处理
    // eslint-disable-next-line prettier/prettier
    var backoff = new Promise(function(resolve) {
      // eslint-disable-next-line prettier/prettier
      setTimeout(function() {
        resolve();
      }, config.retryDelay || 1);
    });

    // 重新发起axios请求
    // eslint-disable-next-line prettier/prettier
    return backoff.then(function() {
      return axios(config);
    });
  }
);
/**
 * 封装axios的post请求
 *
 * @export
 * @param {*} url
 * @param {*} params
 * @param {*} retry   是否重试
 * @returns
 */
export function postDataBase(url, params, retry) {
  axios.defaults.retry = retry;
  return new Promise((resolve, reject) => {
    axios
      .post(url, params)
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        reject(error);
      });
  });
}
/**
 * 默认重试 post
 *
 * @export
 * @param {*} url
 * @param {*} params
 * @returns
 */
export function postDataRetry(url, params) {
  return postDataBase(url, params, true);
}

/**
 * 普通 post
 *
 * @export
 * @param {*} url
 * @param {*} params
 * @returns
 */
export function postData(url, params) {
  return postDataBase(url, params, false);
}

/**
 * 封装axios的get请求
 *
 * @export
 * @param {*} url
 * @param {*} params
 * @returns
 */
export function getDataBase(url, params, retry) {
  axios.defaults.retry = retry;
  return new Promise((resolve, reject) => {
    axios
      .get(url, { params: params })
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        reject(error);
      });
  });
}

/**
 * 默认重试 get
 *
 * @export
 * @param {*} url
 * @param {*} params
 * @returns
 */
export function getDataRetry(url, params) {
  axios.defaults.retry = true;
  return getDataBase(url, params, true);
}

/**
 * 普通 get
 *
 * @export
 * @param {*} url
 * @param {*} params
 * @returns
 */
export function getData(url, params) {
  axios.defaults.retry = false;
  return getDataBase(url, params, false);
}
